// extracted by mini-css-extract-plugin
module.exports = {"avatar":"PulsingAvatar_avatar__2g3br","pulse":"PulsingAvatar_pulse__3FrdR"};